/* eslint-disable react/prefer-stateless-function */
/* eslint-disable max-len */
import React, { Component } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import 'react-toastify/dist/ReactToastify.css';
import { ContentHeader, BreakoutTile } from 'C4';

// TODO make work with API, grid sucks currently
export default class BreakoutView extends Component {
  render() {
    return (
      <div className="breakoutView">

        <div className="gradient" />
        <div className="bg" />

        <div className="breakoutHolder">
          <ContentHeader
            header="Breakout Sessions"
            subtitle="Enjoy hearing from the experts on some interesting topics relevant to you and your clients today."
            icon="clock"
          />
          <div className="sessions">

            <div className="title" style={{ gridRow: 'span 2' }}>
              <span>Session 1: 11.00</span>
            </div>

            <BreakoutTile
              time="30 minutes"
              title="Roadtrippin’ – an American Classic"
              topic="The re-opening of America begins with the highways and byways, and everything in between as we hit the road to shake off the doldrums of lockdown."
              panelists="AAA, Brand USA, DMO’s and experts"
              speakers="could include AAA, DMO’s, Car rental agencies"
              buttonColor="#cd2d12"
              buttonImage="https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1008&q=80"
            />

            <BreakoutTile
              time="23 minutes"
              title="Travel Insurance Matters – now more than ever?"
              topic="With all the new anxiety and disruptions likely means more questions about travel insurance especially as it relates to what is and what is not covered."
              panelists="Tripmate (Sponsor), USTOA"
              buttonColor="#cd2d12"
              buttonImage="https://front.travpromobile.com/614/insurance.jpg?fit=clamp&"
            />

            <div
              className="title"
              style={{ gridRow: 'span 2' }}
            >

              <span>Session 2: 11.30</span>
            </div>

            <BreakoutTile
              time="25 minutes"
              title="National Parks & Great Outdoors"
              topic="For the next few months open spaces and fresh air await at some our best national treasures.   The US Park system is open for business and can connect your clients like never before"
              panelists="McGilvray films, US Parks Dept, Deleware North"
              buttonImage="https://front.travpromobile.com/614/californication.jpg?fit=clamp&"
            />

            <BreakoutTile
              time="18 minutes"
              title="Luxury Escapes Redefined"
              topic={<div>There are luxury experiences abound throughout the US, particularly in those less explored, off the beaten-path destinations.<br /> Hear from the experts.</div>}
              panelists="Virtuoso, Signature, Amex, AAA"
              buttonImage="https://front.travpromobile.com/614/carrent.jpg?fit=clamp&"
            />

            <div className="title">
              <span>Session 3: 12.00</span>
            </div>

            <BreakoutTile
              time="30 minutes"
              title="How to Travel More Responsibly"
              topic="Moderated by Tourism Cares"
              panelists="ATTA, Tour Operator (REI Travel, TTC), National Parks"
              buttonImage="https://cdn.getyourguide.com/img/location_img-1570-3285976407-148.jpg"
            />

            <div className="title" />

          </div>
          <div className="keynote">
            <h4>Rewatch Keynote</h4>
            <hr />
            <div className="sessions keynote">
              <Link to="/main/breakout-sessions/class/101" className="session">
                <img className="company__image" alt="user" src="https://front.travpromobile.com/614/welcome.jpg?fit=clamp&" />
                <div className="content">
                  <div className="time">
                    <FontAwesomeIcon icon={['fas', 'clock']} /> 30 minutes
                  </div>
                  <span>Welcome!</span>
                  <div className="sub__copy">
                    After the difficult times caused by the Corona outbreak Peru is open for travellers. In this session we will present all the new travel options.
                  </div>
                  <div className="sub__btn">
                    Join Now &gt;
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div className="bottom__bar" />
      </div>
    );
  }
}
